export const mediaQueryLg = 1024;
export const hideShowPaginationButton = 9;
